import React from 'react'
import PropTypes, { number, string } from 'prop-types'

const ZhFlagIcon = ({ size = '36px' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 34 34" fill="none">
      <path
        d="M29.6937 3.12585e-06H4.33663C3.3743 -0.00116213 2.43983 0.323492 1.68489 0.921255C0.793997 1.61786 0.210831 2.63618 0.0603016 3.75816C0.0328431 3.94635 0.0184929 4.13623 0.017334 4.32641V29.6736C0.0186332 30.5475 0.285447 31.4004 0.782331 32.1188C1.0344 32.4816 1.34018 32.8039 1.68916 33.0745C2.44409 33.6692 3.37617 33.9936 4.33663 33.9957H29.6937C30.8308 33.9867 31.9188 33.5303 32.7228 32.7249C33.5269 31.9195 33.9826 30.8298 33.9915 29.6908V4.32641C33.9803 3.18816 33.5239 2.09971 32.7204 1.29481C31.9168 0.489902 30.8301 0.0327374 29.6937 0.0215223V3.12585e-06ZM9.73038 12.9577L6.88523 10.9818L4.04008 12.9706L5.02427 9.60421L2.28226 7.45176L5.72051 7.36138L6.87232 4.05092L8.02416 7.36138L11.4624 7.45176L8.72041 9.60421L9.73038 12.9577ZM14.5912 3.91747L13.9852 2.88428L15.0983 3.31477L15.9278 2.34186L15.7688 3.63333L16.869 4.11117L15.67 4.41251L15.5969 5.60928L14.978 4.58903L13.7574 4.83869L14.5912 3.91747ZM15.6957 16.1476L15.6657 17.3487L15.021 16.2897L13.8004 16.6384L14.6041 15.6827L13.9637 14.6668L15.0855 15.0628L15.7903 14.1243V15.3685L16.8733 15.7645L15.6957 16.1476ZM18.0381 6.95241L17.8747 5.79439L18.6741 6.6812L19.856 6.16461L19.2414 7.16765L20.0494 8.1018L18.8675 7.88656L18.2744 8.94988L18.1369 7.72728L16.8476 7.52494L18.0381 6.95241ZM19.5853 13.7111L18.6011 13.018L17.6298 13.7541L18.0123 12.5832L16.9292 11.8428H18.1885L18.5624 10.6718L18.9191 11.8169H20.2085L19.2243 12.5057L19.5853 13.7111Z"
        fill="#E10E00"
      />
      <path
        d="M8.037 7.36582L6.88519 4.05536L5.73337 7.36582L2.28223 7.45622L5.02423 9.59575L4.04003 12.9579L6.88519 10.969L9.73034 12.9579L8.74614 9.59575L11.4881 7.45622L8.037 7.36582Z"
        fill="#F9CF00"
      />
      <path
        d="M15.5968 5.61354L15.6699 4.41679L16.8689 4.11544L15.7687 3.6376L15.9234 2.33752L15.0939 3.31473L13.9851 2.87994L14.5911 3.91311L13.7573 4.84727L14.9736 4.59329L15.5968 5.61354Z"
        fill="#F9CF00"
      />
      <path
        d="M18.2743 8.95005L18.8502 7.87382L20.0278 8.08476L19.2199 7.1506L19.8387 6.14756L18.6568 6.66415L17.8574 5.77734L18.0165 6.93966L16.8604 7.52513L18.1325 7.72746L18.2743 8.95005Z"
        fill="#F9CF00"
      />
      <path
        d="M18.9147 11.8255L18.5623 10.6848L18.1841 11.8557L16.9248 11.8471L17.995 12.566L17.6082 13.7369L18.5838 13.0008L19.5637 13.6939L19.1983 12.5143L20.1868 11.8255H18.9147Z"
        fill="#F9CF00"
      />
      <path
        d="M15.773 14.1113L15.0682 15.0455L13.9464 14.6494L14.5868 15.6654L13.7788 16.6211L14.9994 16.2724L15.6484 17.3314L15.6784 16.1346L16.8346 15.7472L15.7515 15.3511L15.773 14.1113Z"
        fill="#F9CF00"
      />
    </svg>
  )
}

export default React.memo(ZhFlagIcon)

ZhFlagIcon.propTypes = {
  size: PropTypes.oneOfType([string, number]),
}
